import { IAuthorState } from '../../types/redux/author';

/**
 * Этот объект не может быть пустым,
 * страница работает только при получении данных об авторе отчета
 */
export const defaultState = {} as IAuthorState;

export function authorReducer(state: IAuthorState = defaultState) {
  return state;
}
